import { type HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/cn.js";

const badgeVariants = cva(
  "inline-flex h-[22px] items-center rounded-pill px-2.5 font-mono text-[11px] font-semibold uppercase tracking-wider",
  {
    variants: {
      tone: {
        neutral: "bg-surface-2 text-ink-soft",
        accent:  "bg-accent text-accent-on",
        ai:      "bg-ai/15 text-ai border border-ai/30",
        warn:    "bg-warn/20 text-warn",
        risk:    "bg-risk/15 text-risk border border-risk/30",
        success: "bg-success/15 text-success border border-success/30",
        copper:  "bg-copper/15 text-copper",
        system:  "bg-system/15 text-system",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...props }: BadgeProps): JSX.Element {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}

export { badgeVariants };
